export const getNewInspectionTemplateLabels = (t: (key: string) => string) => ({
  createInspectionTypeHeader: t('inspectionTemplate.createInspectionType'),
  cannotBeEmpty: t('inspectionTemplate.cannotBeEmpty'),
  editInspectionTypeHeader: t('inspectionTemplate.editInspectionTypeHeader'),
  formHeading: t('inspectionTemplate.formHeading'),
  nameLabel: t('inspectionTemplate.name'),
  namePlaceholder: t('inspectionTemplate.namePlaceholder'),
  descriptionLabel: t('inspectionTemplate.description'),
  descriptionPlaceholder: t('inspectionTemplate.descriptionPlaceholder'),
  marketLabel: t('inspectionTemplate.market'),
  marketPlaceholder: t('inspectionTemplate.marketPlaceholder'),
  categoryLabel: t('inspectionTemplate.category'),
  categoryPlaceholder: t('inspectionTemplate.categoryPlaceholder'),
  intervalLabel: t('inspectionTemplate.interval'),
  intervalOption1: t('inspectionTemplate.noRecurrentInterval'),
  intervalOption2: t('inspectionTemplate.suggestedInterval'),
  intervalSubInput1: t('inspectionTemplate.intervalSubInput1'),
  intervalSubInput2Placeholder: t('inspectionTemplate.marketPlaceholder'),
  contractorLabel: t('inspectionTemplate.contractor'),
  contractorOption1: t('inspectionTemplate.noDefault'),
  contractorOption2: t('inspectionTemplate.setDefault'),
  otherSettingsLabel: t('inspectionTemplate.otherSettings'),
  otherSettingsOption1: t('inspectionTemplate.useProperty'),
  otherSettingsOption2: t('inspectionTemplate.useApp'),
  resultSettingsLabel: t(
    'inspectionTemplate.resultSettingsForInspectionOccasion'
  ),
  resultRadioLabel: t('inspectionTemplate.resultRadioLabel'),
  resultRadioOption1: t('inspectionTemplate.singleSelectDropdown'),
  resultRadioOption4: t('inspectionTemplate.singleSelectForInspectionPlan'),
  resultRadioOption0: t('inspectionTemplate.noResultForInspectionPlan'),
  resultRadioOption2: t('inspectionTemplate.valueAndUnit'),
  settingsLabelForSingleSelect: t(
    'inspectionTemplate.settingsLabelForSingleSelect'
  ),
  settingsNamePlaceholder: t('inspectionTemplate.settingsNamePlaceholder'),
  enter: t('inspectionTemplate.enter'),
  enterOrSelect: t('inspectionTemplate.enterOrSelect'),
  addAlternativeButtonLabel: t('inspectionTemplate.addAlternative'),
  linkFromProjectLabel: t('inspectionTemplate.linkFromProject'),
  leniencyRequirementLabel: t('inspectionTemplate.leniencyRequirement'),
  additionalDocumentsLabel: t('inspectionTemplate.additionalDocuments'),
  create: t('inspectionTemplate.createInspectionType'),
  save: t('inspectionTemplate.saveInspectionPlan'),
  duplicate: t('inspectionTemplate.duplicate'),
  cancel: t('inspectionTemplate.cancel'),
  unit: t('inspectionTemplate.unit'),
  colorLessThanLabel: t('inspectionTemplate.else'),
  colorGreaterThanLabel: t('inspectionTemplate.below'),
  Interpretation: t('inspectionTemplate.Interpretation'),
  planResultSettingsLabel: t('inspectionTemplate.Interpretation'),
  inspectionPlanResultSettings: t(
    'inspectionTemplate.inspectionPlanResultSettings'
  ),
  approved: t('inspectionTemplate.approved'),
  approvedWithRemarks: t('inspectionTemplate.approvedWithRemarks'),
  notApproved: t('inspectionTemplate.notApproved'),
  ok: t('inspectionTemplate.ok'),
  okWithComments: t('inspectionTemplate.okWithComments'),
  fail: t('inspectionTemplate.fail'),
  enterOrselect: t('inspectionTemplate.enterOrselect'),
  inspectionTemplateDoc: t('inspectionTemplate.inspectionTemplateDoc'),
  dragAndDropLabel: t('inspectionTemplate.dragAndDropLabel'),
  browseLabel: t('inspectionTemplate.browseLabel'),
  upload: t('inspectionTemplate.upload'),
  additionalDocument: t('inspectionTemplate.additionalDocument'),
  inspectionIntervalHint: t('inspectionIntervalHint'),
  inspectionResultSettingsHint: t('inspectionResultSettingsHint'),
  caseManagementTemplate: t('caseManagementTemplate'),
  template: t('templateTitle'),
  noTemplate: t('noTemplate'),
  organizationSpecificTemplates: t('organizationSpecificTemplates'),
  globaltemplates: t('globaltemplates'),
  issueNumbering: t('inspectionTemplate.issueNumbering'),
  issueNumberingHint: t('inspectionTemplate.issueNumberingHint'),
  inspectionSeparateIssueCount: t('inspectionTemplate.inspectionSeparateIssueCount'),
  inspectionWholeIssueCount: t('inspectionTemplate.inspectionWholeIssueCount'),
});

export type InspectionLabels = ReturnType<
  typeof getNewInspectionTemplateLabels
>;
